<adapt-configuration-page-base [configGroups]="configGroups"
                               configTitle="Organisation configuration"
                               (selectedItemChange)="selectedItem = $event">
    <!-- system -->
    @if (selectedItem?.area === ConfigArea.OrganisationProfile) {
        <adapt-configure-organisation-profile [configItem]="selectedItem"></adapt-configure-organisation-profile>
    }
    @if (selectedItem?.area === ConfigArea.ExternalLink) {
        <adapt-configure-external-dashboard [configItem]="selectedItem"> </adapt-configure-external-dashboard>
    }
    @if (selectedItem?.area === ConfigArea.CalendarIntegration) {
        <adapt-configure-calendar-integration [configItem]="selectedItem"></adapt-configure-calendar-integration>
    }
    <!-- @if (selectedItem?.area === ConfigArea.FeatureFlags) {
        <adapt-configure-feature-flags [configItem]="selectedItem"></adapt-configure-feature-flags>
        }
    -->
    @if (selectedItem?.area === ConfigArea.PathwayCompletion) {
        <adapt-configure-pathway-completion [configItem]="selectedItem"></adapt-configure-pathway-completion>
    }
    @if (selectedItem?.area === ConfigArea.AI) {
        <adapt-configure-ai-assistant [configItem]="selectedItem"> </adapt-configure-ai-assistant>
    }

    <!-- organisation-->
    @if (selectedItem?.area === ConfigArea.Labels) {
        <adapt-configure-labels [configItem]="selectedItem"></adapt-configure-labels>
    }
    @if (selectedItem?.area === ConfigArea.PersonalProfileCategories) {
        <adapt-configure-personal-profile [configItem]="selectedItem"></adapt-configure-personal-profile>
    }

    <!-- strategy -->
    @if (selectedItem?.area === ConfigArea.PurposeAndVision) {
        <adapt-configure-purpose-and-vision [configItem]="selectedItem"></adapt-configure-purpose-and-vision>
    }
    @if (selectedItem?.area === ConfigArea.ValuesConstitution) {
        <adapt-configure-values-constitution [configItem]="selectedItem"></adapt-configure-values-constitution>
    }

    @if (hasGenericConfig(selectedItem?.area)) {
        <adapt-configure-generic-feature [configItem]="selectedItem"></adapt-configure-generic-feature>
    }

    @if (selectedItem?.area === ConfigArea.ObjectivesAndKeyResults) {
        <adapt-configure-objectives [configItem]="selectedItem"></adapt-configure-objectives>
    }
    <!-- teams -->
    @if (selectedItem?.area === ConfigArea.Team) {
        <adapt-configure-teams [configItem]="selectedItem"></adapt-configure-teams>
    }
    @if (selectedItem?.area === ConfigArea.Kanban) {
        <adapt-configure-work [configItem]="selectedItem"></adapt-configure-work>
    }
    @if (selectedItem?.area === ConfigArea.Meetings) {
        <adapt-configure-meetings [configItem]="selectedItem"></adapt-configure-meetings>
    }
</adapt-configuration-page-base>
